import React from "react";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";


const StepGmailSummary = (props) => {
    const {googleAccount, emailFrom} = props;

    return <Stack spacing={2}>
        <Typography variant="body2">
            Cliccando su salva verrà impostato <strong>Gmail</strong> come servizio di invio posta.
        </Typography>
        <Typography variant="body2">
            Le email verranno inviate dal seguente account Google: <strong>{googleAccount.email}</strong>.
        </Typography>
        {
            emailFrom !== googleAccount.email &&
            <Typography variant="body2">
                Verrà utilizzato l'indirizzo <strong>{emailFrom}</strong> come mittente delle email. Assicurati
                che il tuo account gmail sia configurato per inviare le mail come {emailFrom}.
            </Typography>
        }
    </Stack>
}

export default StepGmailSummary;